export default __webpack_public_path__ + "static/media/icon-learn.3ba5e76e.svg";